import { Component, Inject } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { CheckboxDialogOptions } from './checkbox-dialog';


@Component({
    selector: 'app-checkbox-dialog',
    templateUrl: './checkbox-dialog.component.html',
    styleUrls: ['./checkbox-dialog.component.scss']
})
export class CheckboxDialogComponent {
    TitleText?: string;
    MessageText?: string;
    CheckboxLabel?: string;
    CheckboxOption?: boolean;

    checkboxDialogForm!: UntypedFormGroup;

    constructor(
        private fb: UntypedFormBuilder,
        private dialogRef: MatDialogRef<CheckboxDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public opts: CheckboxDialogOptions,
    ) {

        const self = this;
        self.TitleText = opts.TitleText || 'Information Requested...';
        self.MessageText = opts.MessageText || '';
        self.CheckboxLabel = opts.CheckboxLabel || '';
        self.CheckboxOption = opts.CheckboxOption || false;

        self.checkboxDialogForm = self.fb.group({
            CheckboxOption: [self.CheckboxOption],
        });
    }

    CancelHandler(): void {
        this.dialogRef.close(null);
    }

    OKHandler(): void {
        this.dialogRef.close(this.checkboxDialogForm?.controls?.['CheckboxOption'].value);
    }
}
